import React, {FC, ReactNode} from "react"
import classNames from "classnames"

import {Container} from "./styled"
import Markdown from "@irati/ui/src/Markdown"

interface Props {
  className?: string
  comp?: ReactNode | ReactNode[]
  data: string[]
}

const CircledConnector: FC<Props> = ({comp, className, data}) => {
  return (
    <Container className={classNames("circledConnector", className)}>
      {data.map((text, index) => (
        <div className="circledConnector_circledRow" key={text + index}>
          <span className="circledConnector_circled">{index + 1}</span>
          <div className="circledConnector_circledText">
            {text === "renderCompFromProps" && <div>{comp instanceof Array ? comp[index] : comp}</div>}
            {text !== "renderCompFromProps" && (
              <div>
                <Markdown source={text} />
              </div>
            )}
          </div>
        </div>
      ))}
    </Container>
  )
}

export default CircledConnector
